import React from 'react';
import propTypes from 'prop-types';
import {
  STextCard,
  SDescription,
  STitle,
  SCircle,
  SHeader,
  SNumber,
} from 'components/TextGrid/TextCard/styles';

const TextCard = ({ title, index, description, showNumbers, align }) => (
  <STextCard index={index} align={align}>
    {title && (
      <SHeader>
        <STitle>{title}</STitle>
        {showNumbers && (
          <SCircle>
            <p>{'0' + (index + 1).toString()}</p>
          </SCircle>
        )}
      </SHeader>
    )}

    {description && <SDescription>{description}</SDescription>}
  </STextCard>
);

TextCard.propTypes = {
  title: propTypes.string,
  description: propTypes.string,
  align: propTypes.string,
  index: propTypes.number,
  showNumbers: propTypes.bool,
};

export default TextCard;
